// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//


import { xCoveoState } from "@eisinc/App/CoveoConnector/Store/Reducers";
import { addToEndOfChain } from "@insite/client-framework/HandlerCreator";
import { chain, PrepareProduct } from "@insite/client-framework/Store/Pages/ProductDetails/Handlers/DisplayProduct";

export const CoveoStoreAnalyticsObject: typeof PrepareProduct = props => {
    const state = props.getState() as xCoveoState;
    const analyticsObject = (props.product as any).analyticsObject;
    if (state.xCoveo?.trackCoveo && analyticsObject) {
        props.dispatch({
            type: "xCoveo/storeSearchAnalyticsObject",
            analyticsObject,
            query: analyticsObject.queryText,
            searchHub: "",
        } as any);   
    }
};

addToEndOfChain(chain, CoveoStoreAnalyticsObject);
